import React from 'react';
import { bool, shape, string } from 'prop-types';

const CheckColor = ({
  className = '',
  color = '#14803C',
  notUseClass = false,
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={{ color, ...style }} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.79508 15.8769L4.62508 11.7069L3.20508 13.1169L8.79508 18.7069L20.7951 6.70687L19.3851 5.29688L8.79508 15.8769Z" fill="currentColor" />
  </svg>
);

CheckColor.propTypes = {
  className: string,
  notUseClass: bool,
  color: string,
  style: shape({}),
};

export default CheckColor;
